import { render, staticRenderFns } from "./_ProductRow.vue?vue&type=template&id=2e814273"
import script from "./_ProductRow.vue?vue&type=script&lang=js"
export * from "./_ProductRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports